/* eslint-disable no-case-declarations */
import * as types from "~/store/faq/faqType";

const initialState = {
  showedFAQ: { type: "", data: [] },
  allFAQ: [],
  error: "",
  loading: false
};

export default function umcFAQ(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALL_FAQ:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_FAQ_SUCCESS:
      return {
        ...state,
        allFAQ: action.payload,
        showedFAQ: { type: "group", data: action.payload[0] },
        error: "",
        loading: false
      };

    case types.GET_ALL_FAQ_FAIL:
      return { ...state, error: action.error, loading: false };

    case types.UPDATE_SHOWED_FAQ_BY_GROUP:
      const showedFAQ = state.allFAQ.find(
        group => group.name === action.payload
      );
      return { ...state, showedFAQ: { type: "group", data: showedFAQ } };

    case types.UPDATE_SHOWED_FAQ_BY_SEARCH:
      return { ...state, loading: true };

    case types.UPDATE_SHOWED_FAQ_BY_SEARCH_SUCCESS:
      return {
        ...state,
        showedFAQ: { type: "search", data: action.payload },
        loading: false
      };

    case types.UPDATE_SHOWED_FAQ_BY_SEARCH_FAIL:
      return { ...state, error: action.error, loading: false };

    default:
      return state;
  }
}
